import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "./components/Navbar";
import { ScrollToTop } from "./components/ScrollToTop";
import { BottomContactStrip } from "./components/BottomContactStrip";
import { HomePage } from "./pages/HomePage";
import { RestoranPage } from "./pages/RestoranPage";
import { BanketSalaPage } from "./pages/BanketSalaPage";
import { SmestajPage } from "./pages/SmestajPage";
import { GalerijaPage } from "./pages/GalerijaPage";
import { KontaktPage } from "./pages/KontaktPage";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 12
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -12
  }
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.4
};

function App() {
  const location = useLocation();
  const isContactPage = location.pathname === "/kontakt";

  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageVariants}
            transition={pageTransition}
            style={{ minHeight: 0 }}
          >
            <Routes location={location}>
              <Route path="/" element={<HomePage />} />
              <Route path="/restoran" element={<RestoranPage />} />
              <Route path="/banket-sala" element={<BanketSalaPage />} />
              <Route path="/smestaj" element={<SmestajPage />} />
              <Route path="/galerija" element={<GalerijaPage />} />
              <Route path="/kontakt" element={<KontaktPage />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
        {!isContactPage && <BottomContactStrip />}
      </main>
    </div>
  );
}

export default App;

